import PropTypes from "prop-types";

// MUI
import { Box, Grid } from "@mui/material";

// Helpers
import { checkSectionsToDisable } from "@PayPlans/helpers/sections";
import { and, or } from "@/Common/helpers/sonar";

// Layouts
import AddSection from "@/Layouts/components/Buttons/AddSection";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";
import ShowInformation from "@/Layouts/components/Basics/ShowInformation";

import { DATE_FORMAT } from "@/Constants/date";

const PayPlansLayout = (props) => {
	const {
		children,
		htmlComponent = <>Its locked</>,
		data = null,
		allSections = new Map(),
		sections = new Map(),
		disabledSections = [],
		disabled = false,
		isNew = false,
		isValid = false,
		loading = false,
		readOnly = false,
		onActionAddSection = () => {},
	} = props;

	if (data?.locked) {
		return (
			<Grid item xs={12}>
				<RoundedBox>
					<Grid container margin={"30px"}>
						{htmlComponent}
					</Grid>
				</RoundedBox>
			</Grid>
		);
	}

	const error = and(!isValid, !readOnly, !loading);
	const sectionsDisabled = checkSectionsToDisable(allSections, disabledSections);

	return (
		<Box sx={{ width: 1 }}>
			<Grid container position="relative" spacing={1}>
				{children}

				<Grid item xs={12} ml={1} mb={2}>
					<ShowInformation
						alternativeMessage={"Creation prevented by existing errors"}
						useAlternative={isNew}
						error={error}
						createdBy={data?.createdBy?.fullName || ""}
						createdAt={data?.createdAt}
						updatedBy={data?.updatedBy?.fullName || ""}
						updatedAt={data?.updatedAt}
						show={Boolean(data)}
						format={DATE_FORMAT.usDateTime12hUnpadded}
						loading={loading}
					/>
				</Grid>

				<AddSection
					sections={sectionsDisabled}
					sectionsInUse={sections}
					disabled={disabled || loading}
					readOnly={readOnly}
					onActionAdd={onActionAddSection}
				/>
			</Grid>
		</Box>
	);
};
PayPlansLayout.propTypes = {
	children: PropTypes.node,
	htmlComponent: PropTypes.node,
	data: PropTypes.shape({
		locked: PropTypes.bool,
		createdBy: PropTypes.shape({
			fullName: PropTypes.string,
		}),
		createdAt: PropTypes.string,
		updatedBy: PropTypes.shape({
			fullName: PropTypes.string,
		}),
		updatedAt: PropTypes.string,
	}),
	allSections: PropTypes.instanceOf(Map),
	sections: PropTypes.instanceOf(Map),
	disabledSections: PropTypes.array,
	disabled: PropTypes.bool,
	isNew: PropTypes.bool,
	isValid: PropTypes.bool,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionAddSection: PropTypes.func,
};

export default PayPlansLayout;
